<template>
  <div>
    <section class="app-main">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </section>
    <van-tabbar route active-color="#FF6B31" inactive-color="#999">
      <van-tabbar-item to="/home" icon="wap-home-o">
        <span>首页</span>
        <template #icon="props">
          <img :src="props.active ? homeActiveIcon : homeIcon" alt="">
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/template" icon="add-o" v-if="isTeacher || isShopowner || isDistributor">
        <span>创建活动</span>
        <template #icon="props">
          <img :src="props.active ? createActiveIcon : createIcon" alt="">
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/scan" icon="scan" v-if="isShopowner || isGuide || isDistributor">
        <span>扫一扫</span>
        <template #icon="props">
          <img :src="props.active ? scanActiveIcon : scanIcon" alt="">
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/my" icon="user-o">
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active ? myActiveIcon : myIcon" alt="">
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import homeIcon from '@/assets/icons/home.png'
import homeActiveIcon from '@/assets/icons/home_active.png'
import createIcon from '@/assets/icons/create.png'
import createActiveIcon from '@/assets/icons/create_active.png'
import scanIcon from '@/assets/icons/scan.png'
import scanActiveIcon from '@/assets/icons/scan_active.png'
import myIcon from '@/assets/icons/my.png'
import myActiveIcon from '@/assets/icons/my_active.png' 

export default {
  name: 'Layout',
  computed: {
    key() {
      return this.$route.path
    },
    ...mapGetters([
      'isTeacher',
      'isDistributor',
      'isShopowner',
      'isGuide'
    ])
  },
  data() {
    return {
      cachedViews: [],
      homeIcon,
      homeActiveIcon,
      createIcon,
      createActiveIcon,
      scanIcon,
      scanActiveIcon,
      myIcon,
      myActiveIcon,

    }
  }
}
</script>

<style lang="stylus" scoped>
.app-main
  box-sizing: border-box
  max-height calc(100vh - 50px)
  overflow: auto
  color #606266
  &::-webkit-scrollbar
    display none
</style>